import styled from 'styled-components';
import callHelpDesk from '@/assets/Icons/call-helpdesk.svg';
import call from '@/assets/Icons/call-white-border.svg';

export const Container = styled.div`
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    border-radius: 16px;
    border: 1px solid #e8e8e8;
    background: var(--Surface-White, #fff);
`;

export const Upper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
`;

export const CallHelpDesk = styled(callHelpDesk)`
    width: 61.666px;
    height: 53.85px;
    padding: 12px 8px;
`;
export const TextContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`;

export const Heading = styled.div`
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
`;
export const SubHeading = styled.div`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    span {
        color: #f58700;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border-radius: 8px;
    background: #0fa457;
`;
export const Call = styled(call)`
    width: 20px;
    height: 20px;
`;

export const ButtonContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
`;
